import React from "react";
import { Link } from "react-router";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";

const Help = () => {
  return (
    <>
      {/* <TopBar /> */}
      <Header />
      <div className="flex justify-center bg-black text-white mt-24">
        <div className="w-full px-4">
          <div className="lg:w-2/4 w-full mx-auto">
            <h1 className="text-xl lg:text-[1.5rem] mt-10 font-sans font-extrabold mb-2">
                Help
            </h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pulvinar ultrices volutpat. Sed dictum enim vitae enim bibendum bibendum. Ut placerat pellentesque augue, ac euismod risus ullamcorper in. Sed tincidunt orci eu pretium vestibulum. Sed vel velit vitae risus ultricies rutrum. Phasellus viverra leo id lorem consequat, vitae fermentum arcu molestie. Suspendisse est magna, ornare non viverra pellentesque, posuere eu libero. Vivamus ut metus lorem.

Donec non massa nunc. Nulla vel malesuada eros. Maecenas tempor quam ut enim lobortis imperdiet. Ut id maximus est. In interdum felis ut odio rhoncus, eu porta ante pulvinar. Ut vitae orci sed ipsum cursus faucibus. Integer tempor ipsum sed ipsum tempus, id tempor eros feugiat.

Integer interdum id sem at sagittis. Sed vitae leo in enim hendrerit congue ut in ipsum. In scelerisque, ex et fringilla porta, diam erat malesuada eros, et sodales libero purus non quam. Nunc sit amet aliquam quam. Nunc venenatis laoreet massa. Cras sed dolor dictum, facilisis ligula ut, varius turpis. Aenean aliquet elementum purus, eget lobortis arcu consectetur nec. Donec placerat metus velit, sed pellentesque justo egestas vitae. Vestibulum ac efficitur orci, nec gravida sapien. Suspendisse sed aliquam ligula.
              </p>
                          </div>
          </div>
        </div>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default Help;
